__turbopack_context__.v({
  "form": "FormikTokenInput-module-scss-module__XMGd7q__form",
  "loadingContainer": "FormikTokenInput-module-scss-module__XMGd7q__loadingContainer",
  "loadingText": "FormikTokenInput-module-scss-module__XMGd7q__loadingText",
  "progressContainer": "FormikTokenInput-module-scss-module__XMGd7q__progressContainer",
  "resendCode": "FormikTokenInput-module-scss-module__XMGd7q__resendCode",
  "resendCodeButton": "FormikTokenInput-module-scss-module__XMGd7q__resendCodeButton",
  "resendCodeText": "FormikTokenInput-module-scss-module__XMGd7q__resendCodeText",
  "verificationCodeError": "FormikTokenInput-module-scss-module__XMGd7q__verificationCodeError",
  "verificationTokenFormContainer": "FormikTokenInput-module-scss-module__XMGd7q__verificationTokenFormContainer",
  "verificationTokenFormContainerError": "FormikTokenInput-module-scss-module__XMGd7q__verificationTokenFormContainerError",
  "verifyTokenForm": "FormikTokenInput-module-scss-module__XMGd7q__verifyTokenForm",
});
